export default __webpack_public_path__ + "static/4-mobile-3c386e8da701f8da4920fc6403de4562.webp";